import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { getAuthSession, clearAuthSession } from 'features/auth/authSession';

const AdminDashboardPage = () => {
  const navigate = useNavigate();
  const [adminData, setAdminData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Fetch admin data
    const fetchAdminData = async () => {
      try {
        const session = getAuthSession();
        if (!session) {
          navigate('/auth/login');
          return;
        }

        // Set admin data from session
        setAdminData(session.user);
      } catch (error) {
        console.error('Failed to fetch admin data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAdminData();
  }, [navigate]);

  const handleLogout = () => {
    clearAuthSession();
    navigate('/auth/admin-login', { replace: true });
  };

  if (isLoading) {
    return <div className="text-center py-5">Loading...</div>;
  }

  return (
    <Container fluid className="py-5">
      <Row className="mb-5">
        <Col lg={12}>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="mb-2">Admin Dashboard</h1>
              <p className="text-muted">Welcome back, {adminData?.name || 'Admin'}</p>
            </div>
            <Button variant="outline-danger" onClick={handleLogout}>
              Logout
            </Button>
          </div>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col lg={3} md={6} className="mb-3">
          <Card>
            <Card.Body>
              <Card.Title>Users Management</Card.Title>
              <Card.Text>Manage all users in the system</Card.Text>
              <Button variant="primary" size="sm">
                Manage Users
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={3} md={6} className="mb-3">
          <Card>
            <Card.Body>
              <Card.Title>Shifts Management</Card.Title>
              <Card.Text>Monitor and manage all shifts</Card.Text>
              <Button variant="primary" size="sm">
                Manage Shifts
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={3} md={6} className="mb-3">
          <Card>
            <Card.Body>
              <Card.Title>Bookings</Card.Title>
              <Card.Text>View all bookings and applications</Card.Text>
              <Button variant="primary" size="sm">
                View Bookings
              </Button>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={3} md={6} className="mb-3">
          <Card>
            <Card.Body>
              <Card.Title>Analytics</Card.Title>
              <Card.Text>View system analytics and reports</Card.Text>
              <Button variant="primary" size="sm">
                View Reports
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>Admin Information</Card.Title>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Email:</strong> {adminData?.email}
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>Role:</strong> {adminData?.role?.toUpperCase()}
                  </p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboardPage;
